import { cn } from '@shared/utils';

/*
 * 沒有獨立行為、只有外觀的共用樣式，以 class 常數提供，套在任何元素上都能用。
 * 抽成常數是因為這些值必須處處一致：卡片與標籤各調各的，落差在單看一個畫面時察覺不到。
 */

/** 玻璃質感卡片（設計系統的標準卡片）。 */
export const CARD_CLASS = cn(
  'rounded-lg border border-border bg-card backdrop-blur-md',
);

/** 可點擊的卡片：懸停微放大、邊框加深，按下回縮。 */
export const INTERACTIVE_CARD_CLASS = cn(
  CARD_CLASS,
  'transition-all duration-300 ease-out',
  'hover:scale-[1.01] hover:border-border-hover hover:shadow-lg active:scale-[0.99]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
);

/** 區塊與欄位的小標籤：等寬字、略寬字距。 */
export const LABEL_CLASS =
  'font-mono text-[0.6875rem] tracking-wide text-muted-foreground';

/**
 * 一組清單列收在同一張實色卡片裡，列與列之間以分隔線隔開（設定頁、搜尋結果）。
 * 套在 `<ul>` 上，每一列是 `<li>`。
 */
export const LIST_GROUP_CLASS = cn(
  CARD_CLASS,
  'flex flex-col divide-y divide-border overflow-hidden bg-card-solid',
);

/** 清單列的版面：觸控高度、左右內距與項目間距。可點的列改用 `LIST_ROW_BUTTON_CLASS`。 */
export const LIST_ROW_CLASS = 'flex min-h-14 items-center gap-3 px-4';

/** 整列可點的清單列：懸停與鍵盤聚焦時整列微微變色。 */
export const LIST_ROW_BUTTON_CLASS = cn(
  LIST_ROW_CLASS,
  'w-full text-left transition-colors duration-200 hover:bg-foreground/5',
  'focus-visible:bg-foreground/5 focus-visible:outline-none',
);

/**
 * 膠囊形的選項鍵，例如可一鍵帶入的常用項目。
 *
 * 不用 IonChip：它的內距與邊框寫在 shadow DOM 的 `:host` 上，會被 Tailwind preflight
 * 的 `*` 重設蓋掉，結果沒有邊框、文字貼邊。原生 button 另外附帶鍵盤操作、
 * focus-visible 與 disabled 的原生行為。高度 44px 是行動裝置的觸控下限。
 */
export const CHIP_CLASS = cn(
  'flex min-h-11 shrink-0 items-center gap-1.5 rounded-full',
  'border border-border-hover bg-card px-3.5 text-sm text-foreground',
  'transition-all duration-200 ease-out',
  'hover:border-accent hover:bg-accent-muted',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
  'active:scale-[0.98]',
  'disabled:opacity-40',
);
